import apiClient from './authService';

export const billingService = {
  /** Redirects to Stripe Checkout for the given plan ('starter' | 'professional'). */
  startCheckout: async (plan) => {
    const { data } = await apiClient.post('/api/billing/create-checkout-session', { plan });
    window.location.href = data.url;
  },

  /** Redirects to the Stripe Customer Portal (manage/cancel subscription). */
  openPortal: async () => {
    const { data } = await apiClient.post('/api/billing/create-portal-session');
    window.location.href = data.url;
  },
};
